export default {
  title: {
    CourseDetail: 'รายละเอียดคอร์ส'
  },
  headers: {
    no: 'รหัสคอร์ส',
    name: 'ชื่อคอร์ส',
    category: 'หมวดหมู่',
    type: 'ประเภท',
    status: 'สถานะ',
    sale: 'การขาย'
  },
  label: {
    nameTh: 'ชื่อคอร์ส (TH)',
    nameEn: 'ชื่อคอร์ส (EN)',
    myCourse: 'คอร์สของฉัน',
    noCourseData: 'ไม่พบข้อมูลคอร์ส',
    getTreatment: 'รับบริการรักษา',
    getTreatmentServices: 'รับบริการรักษา/บริการ',
    setEndDate: 'กำหนดวันสิ้นสุดการใช้งาน',
    showCourseListSlip: 'แสดงรายการคอร์สในใบชำระ',
    productDrugServiceList: 'รายการสินค้า สูตรยา และบริการ',
    editCourse: 'แก้ไขข้อมูลคอร์ส',
    type: 'ประเภทคอร์ส',
    availableQuantity: 'จำนวนครั้งที่ใช้ได้'
  },
  placeholder: {
    searchName: 'ค้นหาชื่อคอร์ส',
    searchIdName: 'ค้นหารหัสคอร์ส ชื่อคอร์ส',
    enterId: 'กรอกรหัสคอร์ส',
    nameTh: 'กรอกชื่อคอร์ส (TH)',
    nameEn: 'กรอกชื่อคอร์ส (EN)',
    category: 'กรอกหมวดหมู่',
    enterInfo: 'กรอกข้อมูลคอร์ส',
    selectProductServiceRelevant: 'เลือกรายการสินค้า/บริการที่เกี่ยวข้อง',
    durationOfUsingTheCourse: 'ระยะเวลาในการใช้คอร์ส',
    type: 'ค้นหาชื่อประเภทคอร์ส',
    enterTypeInfo: 'กรอกข้อมูลประเภทคอร์ส'
  },
  toolTip: {
    create: 'สร้างคอร์ส',
    see: 'ดูข้อมูลคอร์ส',
    detail: 'รายละเอียดคอร์ส',
    edit: 'แก้ไขคอร์ส',
    delete: 'ลบคอร์ส',
    useCourse: 'ใช้คอร์ส'
  },
  modal: {
    create: {
      title: 'สร้างคอร์ส',
      success: 'สร้างข้อมูลคอร์สสำเร็จ !'
    },
    edit: {
      title: 'แก้ไขคอร์ส',
      description: 'กรุณาแก้ไขข้อมูลคอร์สที่ต้องการ',
      success: 'แก้ไขข้อมูลคอร์สสำเร็จ',
      type: {
        title: 'แก้ไขข้อมูลประเภทคอร์ส',
        description1: 'คุณกำลังแก้ไขประเภทคอร์ส',
        success: 'แก้ไขประเภทคอร์สสำเร็จ !'
      }
    },
    delete: {
      title: 'ยืนยันการลบคอร์ส',
      description1: 'คุณกำลังลบคอร์ส',
      description2: 'ต้องการดำเนินการต่อหรือไม่',
      type: {
        title: 'ยืนยันการลบประเภทคอร์ส',
        description1: 'คุณกำลังลบประเภทคอร์ส',
        success: 'ลบประเภทคอร์สสำเร็จ !'
      }
    }
  }
}
